import { render, staticRenderFns } from "./comp_Home-ImageCard.vue?vue&type=template&id=89a948bc&scoped=true&"
import script from "./comp_Home-ImageCard.vue?vue&type=script&lang=js&"
export * from "./comp_Home-ImageCard.vue?vue&type=script&lang=js&"
import style0 from "./comp_Home-ImageCard.vue?vue&type=style&index=0&id=89a948bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a948bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
